/**
 * Returns a new array sorted ascending by a date string field.
 */
export function sortByDate(arr, key) {
  return [...(Array.isArray(arr) ? arr : [])].sort(
    (a, b) => String(a[key] || '').localeCompare(String(b[key] || ''))
  );
}

/**
 * Groups an array into a plain object keyed by the result of keyFn.
 */
export function groupBy(arr, keyFn) {
  const m = {};
  (Array.isArray(arr) ? arr : []).forEach(item => {
    const k = keyFn(item);
    if (!m[k]) m[k] = [];
    m[k].push(item);
  });
  return m;
}
